// extracted by mini-css-extract-plugin
export default {"dynamic-media-picture":"ggkhLLz","transparent":"I6aZiLu","loading":"rCGiWyg","noLogo":"X7zQ97d","image":"nEQDhZB","objectFit":"Ox6tjGv"};